import { NavObjectType, lddGlobalSessionInfo } from '../../Components/navigationTypes'
import { ActivityCenterContextType } from '../../Context/ActivityCenter';
import { getDataReader } from '../../livedataFuncs';
import { store } from '../../redux/store';
import { NewFormDataType } from '../../util/rpwTypes';
import { ClientConnectNotificationResponse, DRNotificationResponse, NormalizedNotification, Bulletin, RenAINotificationResponse } from './notificationsTypes';
const blogURL = "https://docs.google.com/spreadsheets/d/1ABPhoYtnj4Fb-EXqazuhZa4Umr97ZRCG0C1cmjXJ4XM/gviz/tq?tqx=out:json&tq&gid=0";

export const getMainNotifications = async(sessionInfo: lddGlobalSessionInfo): Promise<NormalizedNotification[][]> => {
    const ccNotifs = await getClientConnectNotifications(sessionInfo);
    const drNotifs = await getDRNotifications(sessionInfo);
    const renaiNotifs = [];
    if (ccNotifs.length || drNotifs.length || renaiNotifs.length) {
        const notifications = sortNotificationsArrayByDate([...ccNotifs, ...drNotifs, ...renaiNotifs]);
        const grouped = groupNotificationsByIdentifier(notifications);
        return grouped;
    }
    return [];
}

// API CALLS
export const getBulletins = async (): Promise<NormalizedNotification[]> => {
    try {
        const response = await fetch(blogURL);
        if (response) {
            const text = await response.text();
            const jsonString = text.substring(47).slice(0, -2);
            const json = JSON.parse(jsonString);
            const rows = json.table.rows;
            const appCode = store?.getState()?.SessionInfo?.appCode;
            var myBulletins: Array<Bulletin> = [];
            for (var i = 0; i < rows.length; i++) {
                var cols = rows[i].c;
                var release = (cols[6]) ? cols[6].v : "";
                var condition = (cols[5]) ? cols[5].v : "";
                if (release !== "uat" && release !== "live" && release !== "beta" ) continue;
                else if (window.location.href.indexOf("lawyerdonedeal.com") !== -1 && release === "uat") continue;
                if(release === "beta" && window.location.href.indexOf("rplustest") === -1) continue; // if release = beta and we aren't in beta
                if (condition > "" && condition.indexOf(`|${appCode}|`) === -1) continue;
                myBulletins.push({ id: (cols[0]) ? parseInt(cols[0].v) : 0, title: (cols[1]) ? cols[1].v : "", msg: (cols[2]) ? cols[2].v : "", date: (cols[3]) ? cols[3].f : "", open: (cols[4]) ? cols[4].v : "", condition: condition, release: release })
            }
            const sortedBulletins = sortNotificationsByDate(normalizeBulletinNotifications(myBulletins));
            return sortedBulletins;
        }
    } catch (e) {
        console.log(`failed to fetch google bulletins ${e}`);
    }
    return [];
}
export const getRenaiNotifications = async (SessionInfo: lddGlobalSessionInfo) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_DSAPI_ENDPOINT}/notifications/${SessionInfo.appProvinceShort}/${SessionInfo.firm.id}/getNotifications/renai?SessionID=${SessionInfo.sid}`);
        if (response) {
            const responseJSON = await response.json();
            if (!responseJSON.ok) {
                throw new Error("Failed to fetch RenAI notifications.");
            }
            const sortedCols = groupNotifications(sortNotificationsByDate(normalizeRenaiNotifications(responseJSON.result)));
            return sortedCols;
        }
    } catch (e) {
        console.log('Unable to get RenAI notifications: ', e)
    }
    return [];
}
const getClientConnectNotifications = async (SessionInfo: lddGlobalSessionInfo) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_DSAPI_ENDPOINT}/notifications/${SessionInfo.appProvinceShort}/${SessionInfo.firm.id}/getNotifications/clientconnect?SessionID=${SessionInfo.sid}`);
        if (response) {
            const responseJSON = await response.json();
            if (!responseJSON.ok) throw "Failed to fetch client connect notifications.";
            const sortedCols = groupNotifications(sortNotificationsByDate(normalizeClientConnectNotifications(responseJSON.result)));
            return sortedCols;
        }
    } catch (e) {
        console.log('Unable to get client connect notifications: ', e)
    }
    return [];
}

const getDRNotifications = async (SessionInfo: lddGlobalSessionInfo): Promise<NormalizedNotification[][]> => {
    try {
        const response = await fetch(`${process.env.REACT_APP_DSAPI_ENDPOINT}/dr/${SessionInfo.appProvinceShort}/${SessionInfo.firm.id}/${SessionInfo.user.account}/inbox?type=1&esign=1&SessionID=${SessionInfo.sid}`);
        if (response) {
            const responseJSON = JSON.parse(await response.text());
            if (responseJSON.ok) {
                const cols = responseJSON.result;
                const normalizedCols = normalizeDRNotifications(cols);
                return normalizedCols;
            }
        }
    } catch (e) {
        console.log(e);
    }
    return [];
}

export const getNewDRNotificationCount = async (notifications: NormalizedNotification[], SessionInfo: lddGlobalSessionInfo): Promise<number> => {
    try {
        let timeQryParam = notifications.length > 0 ? notifications[0].date : '';
        const response = await fetch(`${process.env.REACT_APP_DSAPI_ENDPOINT}/dr/${SessionInfo.appProvinceShort}/${SessionInfo.firm.id}/${SessionInfo.user.account}/new?SessionID=${SessionInfo.sid}&Time=${timeQryParam}`);
        if (response && response.ok) {
            const responseJSON = JSON.parse(await response.text());
            if (typeof responseJSON === 'number') {
                return responseJSON;
            }
        }
    } catch (e) {
        console.log(e);
    }
    return 0;
}

export const getNewClientConnectNotifications = async (notifications: NormalizedNotification[], SessionInfo: lddGlobalSessionInfo) => {
    try {
        let timeQryParam = notifications.length > 0 ? notifications[0].date : '';
        const url = `${process.env.REACT_APP_DSAPI_ENDPOINT}/notifications/${SessionInfo.appProvinceShort}/${SessionInfo.firm.id}/getNewNotifications/clientconnect?SessionID=${SessionInfo.sid}&Time=${timeQryParam}`;
        const response = await fetch(url)
        if (response && response.ok) {
            const text = await response.text();
            const result = JSON.parse(text);
            return result;
        } else {
            return {ok: false, error: "Internal server error"}
        }
    } catch (e) {
        console.log('Unable to get new client connect notifications: ', e)
        return { ok: false, error: e };
    }
}

export const getNewRenaiNotifications = async (notifications: NormalizedNotification[], SessionInfo: lddGlobalSessionInfo) => {
    try {
        let timeQryParam = notifications.length > 0 ? notifications[0].date : '';
        const url = `${process.env.REACT_APP_DSAPI_ENDPOINT}/notifications/${SessionInfo.appProvinceShort}/${SessionInfo.firm.id}/getNewNotifications/renai?SessionID=${SessionInfo.sid}&Time=${timeQryParam}`;
        const response = await fetch(url)
        if (response && response.ok) {
            const text = await response.text();
            const result = JSON.parse(text);
            return result;
        } else {
            return {ok: false, error: "Internal server error"}
        }
    } catch (e) {
        console.log('Unable to get new RenAI notifications: ', e)
        return { ok: false, error: e };
    }
}

export const updateNotificationIndicator = (notifications: NormalizedNotification[][]) => {
    let hasUnread = false;
    let count = 0;
    for (let notif of notifications) {
        const groupHasUnread = notif.some(n => !n.read);
        if (groupHasUnread) {
            hasUnread = true;
            count += 1;
        }
    }
    if (hasUnread) {
        document.getElementById("lddNotificationBadgeMainBarNew").classList.add("show");
        document.getElementById("lddNotificationBadgeMainBarNew").textContent = count.toString();
    } else {
        document.getElementById("lddNotificationBadgeMainBarNew").classList.remove("show");
    }
}

export const markNotificationAsRead = async (SessionInfo: lddGlobalSessionInfo, normalizedNotification: NormalizedNotification): Promise<boolean> => {
    try {
        if (normalizedNotification.type === 'DR') {
          const url = `${process.env.REACT_APP_DSAPI_ENDPOINT}/dr/${SessionInfo.firm.id}/${SessionInfo.user.account}/${normalizedNotification.msgID}/read?title=${normalizedNotification.title}&fileID=${normalizedNotification.matterID}&SessionID=${SessionInfo.sid}`;
          const options = {
                method: 'PUT',
                headers: { "Content-Type": "application/json" },
            }
            const response = await fetch(url, options);
            if (response && response.ok) {
                const resJson = await response.json();
                return resJson.ok;
            }
        } else {
            const mergedNotifications = (normalizedNotification as any).mergedNotifications || [{ ...normalizedNotification }];
            
            const promises = mergedNotifications.map(async (notif: NormalizedNotification) => {
                try {
                    const stringBody = JSON.stringify(notif);
                    const options = {
                        method: 'PUT',
                        body: stringBody,
                        headers: { "Content-Type": "application/json" },
                    };
                    const url = `${process.env.REACT_APP_DSAPI_ENDPOINT}/notifications/${SessionInfo.appProvinceShort}/${SessionInfo.firm.id}/updateNotification/read/clientconnect?SessionID=${SessionInfo.sid}`;
                    const response = await fetch(url, options);
                    if (response && response.ok) {
                        const resJson = await response.json();
                        return resJson.ok;
                    }
                    return false;
                } catch (e) {
                    console.log('Error marking notification as read: ', e);
                    return false;
                }
            });
            
            const results = await Promise.all(promises);
            return results.every(r => r === true);
        }
    } catch (e) {
        console.log('unable to mark as read: ', e)
    }
    return false;
}
export const markAllNotificationsAsRead = (SessionInfo: lddGlobalSessionInfo, normalizedNotifications: NormalizedNotification[]) => {
    try {
        const unreadNotifications = normalizedNotifications.filter(notif => !notif.read);
        if (unreadNotifications.length === 0) {
            return null;
        }
        const stringBody = JSON.stringify(unreadNotifications)
        const options = {
            method: 'PUT',
            body: stringBody,
            headers: { "Content-Type": "application/json", },
        }
        const url = `${process.env.REACT_APP_DSAPI_ENDPOINT}/notifications/${SessionInfo.appProvinceShort}/${SessionInfo.firm.id}/updateNotification/readall/clientconnect?SessionID=${SessionInfo.sid}`
        const response = fetch(url, options);
        if (response){
             return response;
            }
    } catch (e) {
        console.log('unable to mark as read: ', e)
        return null;
    }
}
export async function checkReadBulletins(sid: string, lastLoadedBulletinId: number) {
    try {
        if (lastLoadedBulletinId === null) {
            return;
        }
        //TODO: pickup current app folder 
        var res = await fetch(`getprofile.asp?pname=BulletinsRead&SessionID=${sid}`);
        var textData = await res.text();
        const xmlData = new ajaxslt.XDocument();
        xmlData.loadXML(textData);
        var readBulletinID = -1;
        const rootNodes = xmlData.getElementsByTagName("Root");
        if (rootNodes && rootNodes.length > 1) {
            var id = rootNodes[1].getAttribute("id");
            if (id > "") {
                readBulletinID = parseInt(id);
            }
        }
        
        let tmp = document.getElementById("lddNotificationBadgeMainBar");
        if (tmp) {
            if (lastLoadedBulletinId > readBulletinID) {
                tmp.classList.add("show");
            } else {
                tmp.classList.remove("show");
            }
        }
    } catch (e) {
        console.log(e)
    }
}
export async function setReadBulletins(sid: string, lastLoadedBulletin: number) {
    try {
        if (lastLoadedBulletin === null) {
            return;
        }
        // TODO: pick current app folder
        fetch(`saveprofile.asp?pname=BulletinsRead&SessionID=${sid}`, {
            method: "POST",
            body: `<Root id="${lastLoadedBulletin}"></Root>`
        });
    } catch (e) {
        console.log(e)
    }
}

// Helper Functions

const normalizeDRNotifications = (drNotifications: DRNotificationResponse[]): NormalizedNotification[][] => {
    const normalizedArray: NormalizedNotification[][] = [];
    if (!drNotifications || drNotifications.length <= 0) return normalizedArray;
    for (let i = 0; i < drNotifications.length; i++) {
        const temp: NormalizedNotification[] = [{
            type: "DR",
            title: drNotifications[i].MsgType == '5' ? drNotifications[i].NeedSign
              ? "Esign" : "NewHome" : "Mortgage Instructions",
            msgType: drNotifications[i].MsgType,
            message: drNotifications[i].ProjectName,
            date: drNotifications[i].LastPostingDate ?? drNotifications[i].AvailableDate,
            read: drNotifications[i].ReadStatus == 1 || drNotifications[i].ReadStatus == 3, // read or closed
            readStatus: drNotifications[i].ReadStatus,
            clientName: drNotifications[i].Description,
            appId: drNotifications[i].AppID ? String(drNotifications[i].AppID) : null,
            fileNo: drNotifications[i].FileNum,
            msgID: String(drNotifications[i].MsgID),
            builder: drNotifications[i].Builder,
            lender: drNotifications[i].MsgType === '1' ? drNotifications[i].BankName : drNotifications[i].SenderName,
            matterID: drNotifications[i].MatterID,
            lawyerId: drNotifications[i].LSUCID,
            srcApp: drNotifications[i].SrcApp,
            esign: drNotifications[i].NeedSign,
        }];
        normalizedArray.push(temp);
    }
    return normalizedArray;
}

const normalizeRenaiNotifications = (renaiNotifResponse: RenAINotificationResponse[]): NormalizedNotification[] => {
    const normalizedArray: NormalizedNotification[] = [];
    if (renaiNotifResponse && renaiNotifResponse.length !== 0) {
        for (let i = 0; i < renaiNotifResponse.length; i++) {
            const temp: NormalizedNotification = {
                type: 'RenAI',
                title: renaiNotifResponse[i].Action,
                message: renaiNotifResponse[i].Message,
                date: renaiNotifResponse[i].CreatedDate,
                read: renaiNotifResponse[i].Read,
                clientName: renaiNotifResponse[i].ClientName,
                fileNo: renaiNotifResponse[i].FileNo,
                appId: renaiNotifResponse[i].AppId,
                rowKey: renaiNotifResponse[i].rowKey,
                partitionKey: renaiNotifResponse[i].partitionKey,
                fileLocation: renaiNotifResponse[i].FileLocation ?? '',
                fromAddress: renaiNotifResponse[i].FromAddress ?? ''
            }
            normalizedArray.push(temp)
        }
    }
    return normalizedArray;
}

const normalizeClientConnectNotifications = (ccNotifResponse: ClientConnectNotificationResponse[]): NormalizedNotification[] => {
    const normalizedArray: NormalizedNotification[] = [];
    if (ccNotifResponse && ccNotifResponse.length !== 0) {
        for (let i = 0; i < ccNotifResponse.length; i++) {
            const isIDVerification = ccNotifResponse[i].Message === "A client has submitted an ID Verification to ClientConnect";
            const temp: NormalizedNotification = {
                type: 'ClientConnect',
                title: isIDVerification ? "ID Verification" : ccNotifResponse[i].Action,
                message: ccNotifResponse[i].Message,
                date: ccNotifResponse[i].CreatedDate,
                read: ccNotifResponse[i].Read,
                clientName: ccNotifResponse[i].ClientName,
                fileNo: ccNotifResponse[i].FileNo,
                appId: ccNotifResponse[i].AppId,
                rowKey: ccNotifResponse[i].rowKey,
                partitionKey: ccNotifResponse[i].partitionKey
            }
            normalizedArray.push(temp)
        }
    }
    return normalizedArray;
}
const normalizeBulletinNotifications = (bulletins: Bulletin[]): NormalizedNotification[] => {
    const normalizedArray: NormalizedNotification[] = [];
    for (let i = 0; i < bulletins.length; i++) {
        const temp: NormalizedNotification = {
            id: bulletins[i].id,
            type: 'Bulletin',
            title: bulletins[i].title,
            message: bulletins[i].msg,
            date: bulletins[i].date,
            read: true,
            clientName: '',
            fileNo: '',
            link: bulletins[i].open
        }
        normalizedArray.push(temp)
    }
    return normalizedArray;
}
const sortNotificationsByDate = (notifications: NormalizedNotification[]) => {
    const sortedArray: NormalizedNotification[] = [...notifications];
    sortedArray.sort(function (a, b) {
        const aDate = new Date(a.date);
        const bDate = new Date(b.date);
        return aDate > bDate ? -1 : 0;
    });

    return sortedArray;
}

const sortNotificationsArrayByDate = (notifications: NormalizedNotification[][]): NormalizedNotification[][] => {
    const sortedArray: NormalizedNotification[][] = [...notifications];

    sortedArray.sort((a, b) => b[0].date > a[0].date ? 0 : -1);

    return sortedArray;
}

export const createSubarrays = (array: any[], n: number): any[][] => {
    const subarrays = [];
    for (let i = 0; i < array.length; i += n) {
        subarrays.push(array.slice(i, i + n));
    }
    return subarrays;
}

function isStringValid(str: string): boolean {
    return str && str!=='NULL' && str!=='null';
}

function renderDRMessage(data: NormalizedNotification): string {
    if (data.type !== 'DR') return;

    const commonPrefix = isStringValid(data.clientName) ? ` for ${data.clientName}` : '';
    const commonSuffix = ` regarding ${data.message}.`;

    if (data.title === 'Mortgage Instructions') {
        const action = data.readStatus === 0 ? 'sent you' : 'updated';
        return `${data.lender} has ${action} new mortgage instructions${commonPrefix}.`;
    }

    if (data.title === 'NewHome') {
        const userAction = data.readStatus === 0 ? 'received a new deal' : 'received an update';
        const builderAction =  data.readStatus === 0 ? 'sent you a new deal' : 'updated information';
        const builderPart = isStringValid(data.builder) ? `${data.builder} has ${builderAction} for ${data.clientName}${commonSuffix}` : `You have ${userAction}${commonPrefix}${commonSuffix}`;
        return builderPart;
    }
}

export const addNotificationAlertToActivityCenter = async (numberOfNewNotifications: number, activityCenterAdd: ActivityCenterContextType["Add"], notifications: NormalizedNotification[][]): Promise<string> => {

    const retVal = numberOfNewNotifications === 1 ? (
            notifications[0][0].type === 'DR' ? renderDRMessage(notifications[0][0]) : `${notifications[0][0].clientName} ${notifications[0][0].message}.`
        )
         :
        `There are ${numberOfNewNotifications} new Notifications.`;

    activityCenterAdd(retVal, undefined, 'notification', undefined); // consider changing icon
    return retVal;
}

function groupNotifications(notifications) {
    const grouped = [];

    notifications.forEach(notification => {
        const { title, date, fileNo, clientName } = notification;
        const dayOfMonth = new Date(date).getDate();

        // Check if there's already a group for the title and day
        const existingGroup = grouped.find(group => (
            group[0]?.fileNo === fileNo &&
            group[0]?.title === title &&
            group[0]?.clientName === clientName &&
            new Date(group[0]?.date).getDate() === dayOfMonth
        ));

        // If a group exists, add the notification to it
        if (existingGroup) {
            existingGroup.push(notification);
        } else {
            // Otherwise, create a new group
            grouped.push([notification]);
        }
    });

    return grouped;
}

/**
 * Reduce dimension to 1-d
 */
export function flattenGroupedNotifications(groupedNotifications: NormalizedNotification[][]): NormalizedNotification[] {
    return groupedNotifications.reduce((flattened, group) => flattened.concat(group), []);
}

export const groupNotificationsByIdentifier = (notifications: NormalizedNotification[][]): NormalizedNotification[][] => {
    const groupedMap = new Map<string, NormalizedNotification[]>();
    const ungrouped: NormalizedNotification[][] = [];
    
    const isIDVNotification = (notif: NormalizedNotification): boolean => {
        return notif.title === "ID Verification" || 
               (notif.message && notif.message.includes("ID Verification"));
    };
    
    const deduplicateGroup = (group: NormalizedNotification[]): NormalizedNotification[] => {
        const messageMap = new Map<string, NormalizedNotification>();
        
        group.forEach(notif => {
            const messageKey = `${notif.message}_${notif.clientName}_${notif.type}`;
            
            if (messageMap.has(messageKey)) {
                const existingNotif = messageMap.get(messageKey)!;
                const newDate = new Date(notif.date);
                const existingDate = new Date(existingNotif.date);
                
                if (newDate > existingDate) {
                    existingNotif.date = notif.date;
                }
                
                if (!notif.read && !existingNotif.read) {
                    existingNotif.read = false;
                }
                
                if (!(existingNotif as any).mergedNotifications) {
                    (existingNotif as any).mergedNotifications = [{ ...existingNotif }];
                }
                (existingNotif as any).mergedNotifications.push({ ...notif });
            } else {
                messageMap.set(messageKey, notif);
            }
        });
        
        return Array.from(messageMap.values());
    };
    
    notifications.forEach(group => {
        const deduplicatedGroup = deduplicateGroup(group);
        
        const idvNotifications: NormalizedNotification[] = [];
        const nonIdvNotifications: NormalizedNotification[] = [];
        
        deduplicatedGroup.forEach(notif => {
            if (isIDVNotification(notif)) {
                idvNotifications.push(notif);
            } else {
                nonIdvNotifications.push(notif);
            }
        });
        
        idvNotifications.forEach(idvNotif => {
            ungrouped.push([idvNotif]);
        });
        
        if (nonIdvNotifications.length === 0) {
            return;
        }
        
        // Separate DR notifications by title (NewHome vs Mortgage Instructions) before grouping by appId
        const drNotificationsByTitle = new Map<string, NormalizedNotification[]>();
        const otherNotifications: NormalizedNotification[] = [];
        
        nonIdvNotifications.forEach(notif => {
            if (notif.type === "DR" && (notif.title === "NewHome" || notif.title === "Mortgage Instructions")) {
                const titleKey = `${notif.appId || 'noAppId'}_${notif.title}`;
                if (!drNotificationsByTitle.has(titleKey)) {
                    drNotificationsByTitle.set(titleKey, []);
                }
                drNotificationsByTitle.get(titleKey)!.push(notif);
            } else {
                otherNotifications.push(notif);
            }
        });
        
        // Process DR notifications grouped by title+appId
        drNotificationsByTitle.forEach((titleGroup, titleKey) => {
            const firstNotif = titleGroup[0];
            if (!firstNotif || !firstNotif.appId) {
                titleGroup.forEach(notif => ungrouped.push([notif]));
                return;
            }
            
            const groupKey = `DR_${firstNotif.appId}_${firstNotif.title}`;
            
            if (groupedMap.has(groupKey)) {
                const existingGroup = groupedMap.get(groupKey)!;
                
                titleGroup.forEach(newNotif => {
                    const duplicateIndex = existingGroup.findIndex(existingNotif => 
                        existingNotif.message === newNotif.message &&
                        existingNotif.clientName === newNotif.clientName &&
                        existingNotif.type === newNotif.type
                    );
                    
                    if (duplicateIndex !== -1) {
                        const existingNotif = existingGroup[duplicateIndex];
                        const newDate = new Date(newNotif.date);
                        const existingDate = new Date(existingNotif.date);
                        
                        if (newDate > existingDate) {
                            existingNotif.date = newNotif.date;
                        }
                        
                        if (!newNotif.read && !existingNotif.read) {
                            existingNotif.read = false;
                        }
                        
                        if (!(existingNotif as any).mergedNotifications) {
                            (existingNotif as any).mergedNotifications = [{ ...existingNotif }];
                        }
                        (existingNotif as any).mergedNotifications.push({ ...newNotif });
                    } else {
                        existingGroup.push(newNotif);
                    }
                });
                
                existingGroup.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
            } else {
                const newGroup = [...titleGroup];
                newGroup.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
                groupedMap.set(groupKey, newGroup);
            }
        });
        
        // Process other notifications (non-DR or DR with other titles like "Esign")
        if (otherNotifications.length > 0) {
            const firstNotif = otherNotifications[0];
            if (!firstNotif) {
                return;
            }
            
            let groupKey: string | null = null;
            
            if (firstNotif.type === "ClientConnect") {
                if (firstNotif.appId) {
                    groupKey = `ClientConnect_${firstNotif.appId}`;
                }
            } else if (firstNotif.type === "DR") {
                if (firstNotif.appId) {
                    groupKey = `DR_${firstNotif.appId}`;
                }
            }
            
            if (!groupKey) {
                otherNotifications.forEach(notif => {
                    ungrouped.push([notif]);
                });
                return;
            }
            
            if (groupedMap.has(groupKey)) {
                const existingGroup = groupedMap.get(groupKey)!;
                
                otherNotifications.forEach(newNotif => {
                    const duplicateIndex = existingGroup.findIndex(existingNotif => 
                        existingNotif.message === newNotif.message &&
                        existingNotif.clientName === newNotif.clientName &&
                        existingNotif.type === newNotif.type
                    );
                    
                    if (duplicateIndex !== -1) {
                        const existingNotif = existingGroup[duplicateIndex];
                        const newDate = new Date(newNotif.date);
                        const existingDate = new Date(existingNotif.date);
                        
                        if (newDate > existingDate) {
                            existingNotif.date = newNotif.date;
                        }
                        
                        if (!newNotif.read && !existingNotif.read) {
                            existingNotif.read = false;
                        }
                        
                        if (!(existingNotif as any).mergedNotifications) {
                            (existingNotif as any).mergedNotifications = [{ ...existingNotif }];
                        }
                        (existingNotif as any).mergedNotifications.push({ ...newNotif });
                    } else {
                        existingGroup.push(newNotif);
                    }
                });
                
                existingGroup.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
            } else {
                const newGroup = [...otherNotifications];
                newGroup.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
                groupedMap.set(groupKey, newGroup);
            }
        }
    });
    
    const grouped = Array.from(groupedMap.values());
    const allNotifications = [...grouped, ...ungrouped];
    
    return allNotifications.sort((a, b) => {
        const aDate = new Date(a[0]?.date || 0).getTime();
        const bDate = new Date(b[0]?.date || 0).getTime();
        return bDate - aDate;
    });
};

type FileMatchType = {
    AppID: number,
    FileNum: string,
    ClientName: string,
    PropertyAddress: string,
    RANK: number,
}

/**
 * Fuzzy match a DR Builder message to RPW files
 * @param msgID - dr MsgID
 * @param SessionInfo - Session info
 * @param isPassCode - whether to use passcode
 * @returns a list of matched files, with rw file's AppID, ClientName, PropertyAddress
 */
export const fuzzyMatchToRW = async (msgID: string, SessionInfo: lddGlobalSessionInfo, isPassCode: boolean): Promise<FileMatchType[]> => {
    try {
        let url = `${process.env.REACT_APP_DSAPI_ENDPOINT}/dr/${SessionInfo.appProvinceShort}/${SessionInfo.firm.id}/${SessionInfo.user.account}/match?MsgID=${msgID}&SessionID=${SessionInfo.sid}`
        if (isPassCode) {
            url += `&PassCode=1`;
        }
        const response = await fetch(url, {signal: AbortSignal.timeout(5000)});
        if (response) {
            const responseJSON = JSON.parse(await response.text());
            if (responseJSON.ok) {
                const cols = responseJSON.result;
                return cols;
            }
        }
    } catch (e) {
        console.log(e);
    }
    return [];
}

/**
 * RPW file info linked with the msgID
 */
export const getLinkedRWFile = async (msgID: string, SessionInfo: lddGlobalSessionInfo): Promise<any> => {
    try {
        const response = await fetch(`${process.env.REACT_APP_DSAPI_ENDPOINT}/dr/${SessionInfo.appProvinceShort}/${SessionInfo.firm.id}/${SessionInfo.user.account}/link?MsgID=${msgID}&SessionID=${SessionInfo.sid}`);
        if (response) {
            const responseJSON = JSON.parse(await response.text());
            if (responseJSON.ok) {
                const res = responseJSON.result;
                return res;
            }
        }
    } catch (e) {
        console.log(e);
    }
    return null;
}

export const checkFileExists = async (appId: string, SessionInfo: lddGlobalSessionInfo): Promise<boolean> => {
    try {
        const url = `/${process.env.REACT_APP_RWAPI_ENDPOINT}/api/${SessionInfo.appProvinceShort}/${SessionInfo.firm.id}/checkfileexists?AppID=${appId}&SessionID=${SessionInfo.sid}`;
        const response = await fetch(url);
        if (response && response.ok) {
            const responseJSON = await response.json();
            if (responseJSON.ok) {
                return responseJSON.result.exists;
            }
        }
    } catch (e) {
        console.log('Unable to check if file exists: ', e);
    }
    return false;
}

export const drBuilderNavObject = (appID: string): NavObjectType => {
    const drNavObject: NavObjectType = {
        component: 'main',
        url: 'lfmaster.asp',
        label: "Information",
        reactFrame: "builderinfo",
        init: true,
        params: {
            tb: "TPAppXML",
            formasp: "purfileedit",
            id: appID
        },
        controller: {
            tabName: "NewHome",
        }
    };
    return drNavObject;
}
export const drEsignNavObject = (appID: string): NavObjectType => {
  const drNavObject: NavObjectType = {
    component: "main",
    url: "lfmaster.asp",
    label: "Information",
    reactFrame: "builderesign",
    init: true,
    params: {
      tb: "TPAppXML",
      formasp: "purfileedit",
      id: appID,
    },
    controller: {
      tabName: "NewHome",
    },
  };
  return drNavObject;
};

/**
 * To create a new RW file from the inbox
 * @returns nav object
 */
export const createNewFileFromInbox = async (msgID: string, mergeParts: string, formData: NewFormDataType, sessionInfo: lddGlobalSessionInfo): Promise<NavObjectType> => {
    let navObj: NavObjectType;
    let newAppID: string;
    const res = await submitNewLiveForm(sessionInfo.appProvinceShort, sessionInfo, formData);
    if (res.ok) {
        newAppID = res.result;
    }
    if (newAppID > '') {
        if (msgID) {
            navObj = {
                component: "main",
                url: "lfmaster.asp", 
                controller: {
                    tabName: "NewHome",
                    tabNumber: null,
                },
                params: {
                    formasp: "purfileedit",
                    tb: "TPAppXML",
                    id: newAppID,
                    onload: `MergeVIPInfoNode(${msgID});SetPageDirty();`,
                    compat: "1",
                    ReactDocument: "-1",
                },
                label: "Information",
                reactFrame: "builderinfo",
                init: true,
            };
        } else {
            navObj = {
                component: "main",
                url: "lfmaster.asp", 
                controller: {
                    tabName: "Basic",
                    tabNumber: 0
                },
                params: {
                    formasp: "purfileedit",
                    tb: "TPAppXML",
                    id: newAppID,
                    onload: `SetPageDirty();`,
                    compat: "1",
                    ReactDocument: "-1",
                },
                init: true,
            };
        }
    } else {
        navObj = {
            component: 'main',
            url: "lfmaster.asp",
            params: {
                formasp: "purfilenew",
                src: "NewLiveFormapp.asp",
                onload: `MergeVIPInfoNode(${msgID});SetPageDirty();`,
            }
        };
    }
    return navObj;
}

export async function submitNewLiveForm(provinceCode: string, sessionInfo: lddGlobalSessionInfo, formData: NewFormDataType) {
    const ret: any = {ok: false}
    try {
        // get processed live form
        const xml = await getProcessedNewLiveForm(provinceCode, sessionInfo, formData);
        // saveXML
        const url = `/rplus/${provinceCode}/savexml.asp?lfdata=1&compat=1&SessionID=${sessionInfo.sid}`;
        const options = {
            method: "POST",
            headers: {
                'Content-Type': 'text/xml'
            },
            body: xml
        };
        const xmlRes = await fetch(url, options);
        const xmlText = await xmlRes.text();
        // process xml to json
        const xmlDom = new ajaxslt.XDocument();
        xmlDom.loadXML(xmlText);
        const appID = xmlDom.selectSingleNode("Root").selectSingleNode("Info").selectSingleNode("OldData").selectSingleNode("TPAppXML").getAttribute("AppID");
        ret.ok = true;
        ret.result = appID;
    } catch (e) {
        ret.error = e;
    }
    return ret;
}

function GenerateRandomPassCode() {
	var codeLength = 20;
	var legalChars = "23456789ABCDEFGHJKLMNPQRSTUVWXYZ";	//32 chars
	var result = "";
	for(var i=0; i<codeLength; i++)
	{
		var bigNum = (new Date()).getTime() * Math.random();	//should be big but still have decimal part
		var bigInt = Math.floor(bigNum);
		if(i > 0 && i % 5 == 0)
			result += "-";
		result += legalChars.charAt(bigInt % legalChars.length);
	}
	return result;
}

async function getProcessedNewLiveForm(provinceCode: string, sessionInfo: lddGlobalSessionInfo, formData: NewFormDataType): Promise<string> {
    const xmlRes = await fetch(`/rplus/${provinceCode}/getPredefinedCode.asp?type=NewApp&SessionID=${sessionInfo.sid}`);
    const xmlText = await xmlRes.text();
    const xmlDoc = new ajaxslt.XDocument();
    xmlDoc.loadXML(xmlText);
    // add province node
    const provinceDefine = await getProvinceDefine(provinceCode, sessionInfo.sid);
    let pdDoc = new ajaxslt.XDocument();
    pdDoc.loadXML(provinceDefine);
    if (pdDoc) {
		pdDoc = pdDoc.selectSingleNode("ProvinceDefaultDefine");
		if(pdDoc != null)
			xmlDoc.documentElement.lastChild.firstChild.appendChild(pdDoc);
	}
	// generate passcode
	xmlDoc.documentElement.lastChild.firstChild.setAttribute("PassCode", GenerateRandomPassCode());

    // add flag to indicate this new LiveForm is NOT made from webapp
    xmlDoc.documentElement.lastChild.firstChild.setAttribute("NonStandardNewFile", "1");

    // prepare data
    await PrepareNewApplicationData(provinceCode, xmlDoc, sessionInfo, formData);
    return xmlDoc.xml;
}

async function getProvinceDefine(provinceCode: string, sessionID: string): Promise<string> {
    const provinceDefineRes = await fetch(`/rplus/${provinceCode}/getPredefinedCode.asp?type=provincedefine&SessionID=${sessionID}`);
    return await provinceDefineRes.text();
}

async function PrepareNewApplicationData(provinceCode: string, domNewApp: ajaxslt.XDocument, sessionInfo: lddGlobalSessionInfo, formData: NewFormDataType) {
	var appNode = domNewApp.documentElement.selectSingleNode("Data/*");		//should be "TPAppXML" or "Wills"
	if(appNode == null) {
		return;
	}
	await ProcessNewApplicationData(provinceCode, appNode, sessionInfo, formData);
	return;
}

async function getLawyerXML(SessionInfo: lddGlobalSessionInfo, lawyerID: string): Promise<string> {
    try {
        const data = await fetch(`/${process.env.REACT_APP_UVAPI_ENDPOINT}/api/${SessionInfo.firm.id}/uv/get/lawyerxml?SessionID=${SessionInfo.sid}&LawyerID=${lawyerID}`)
        return await data.text();
    } catch (e) {
        console.log(e);
        throw e;
    }
}

async function getFirmUser(SessionInfo: lddGlobalSessionInfo, username: string): Promise<Record<string, any> | undefined> {
    try{
        const res = await fetch(`/${process.env.REACT_APP_UVAPI_ENDPOINT}/api/${SessionInfo?.firm?.id}/uv/get/user?id=${username}&SessionID=${SessionInfo.sid}`);
        const data = await res.json();
        if(data.ok){
            return data.result;
        }
    } catch (e) {
        console.log(e);
    }
}

async function getQPick(SessionInfo: lddGlobalSessionInfo, qpid: string, type: "StaffMember" | "Solicitor"): Promise<string> {
    try {
        const res = await fetch(`/${process.env.REACT_APP_RWAPI_ENDPOINT}/api/${SessionInfo.appProvinceShort}/${SessionInfo.firm.id}/qpick/${qpid}?SessionID=${SessionInfo.sid}&Type=${type}`)
        const data = await res.json();
        if (data.ok) {
            return data.result;
        }
    } catch (e) {
        console.log(e);
        throw e;
    }
}

async function ProcessNewApplicationData(provinceCode: string, appNode: ajaxslt.XNode, sessionInfo: lddGlobalSessionInfo, formData: NewFormDataType) {
	appNode.setAttribute("LawyerID", String(sessionInfo.firm.id));		//for sure
    appNode.setAttribute("MatterNumber", formData.fileNum);
	var oldLawyerNode = appNode.selectSingleNode("lawyer");	//sometimes appNode already contains <lawyer>
	if (oldLawyerNode != null)
		appNode.removeChild(oldLawyerNode);
	appNode.removeAttribute("BDWOS");

    // append lawyer profile
    try {
        const profileRes = await fetch(`getlawyerprofile.asp?SessionID=${sessionInfo.sid}`);
        const profileData = await profileRes.text();
        if (profileData) {
            const profileDoc = new ajaxslt.XDocument();
            profileDoc.loadXML(profileData);
            const lawyerNode = profileDoc.selectSingleNode("Root").selectSingleNode("lawyer");
            if (lawyerNode && lawyerNode != null) {
                appNode.appendParseXML(lawyerNode.xml);
            }    
        }
    } catch (error) {
        console.log(error);
    }
    if ("PSM".indexOf(formData.fileType) >= 0)
        appNode.setAttribute("PSM", formData.fileType);
    // set responsible lawyer
    if (formData.LSUCID > "") {
        const data = await getLawyerXML(sessionInfo, formData.LSUCID);
        var lawyerXML = new ajaxslt.XDocument();
        lawyerXML.loadXML(data.toString());
        for (var childNode of lawyerXML.firstChild.attributes) {
            appNode.setAttribute(childNode.nodeName, childNode.nodeValue);
        }
    }
    // set ClosingDate
    if (formData.closingDate > "" && isDateValid(formData.closingDate)) {
        appNode.setAttribute("ClosingDate", formData.closingDate);
    }
    // set firm contact
    if (formData.firmContact) {
        const qryRes = await getFirmUser(sessionInfo, formData.firmContact);
        if (qryRes) {
            const firmContactInfo = { ...qryRes };
            if (firmContactInfo.JobTitle != null) firmContactInfo.Position = firmContactInfo.JobTitle;
            if (firmContactInfo.SubUsername != null) firmContactInfo.LDDUserName = firmContactInfo.SubUsername;
            const DataReaderObj = getDataReader(appNode as unknown as Element);
            DataReaderObj.setFirmContactInfo(firmContactInfo, true);
        }
    }
}

/****** helper funcs *********/

function isDateValid(dateStr: string): boolean {
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (dateRegex.test(dateStr)) {
        return !isNaN((new Date(dateStr)).getTime());
    }
    return false;
}